import { Component, ViewChild } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';

import {
  SKY_LINK_RECORDS_STATUSES,
  SkyLinkRecordsComponent,
  SkyLinkRecordsMatchModel
} from '../../core';

const getWindow = () => {
  return window;
};


export class SkyLinkRecordsDemoComponent {
  
  public item: SkyLinkRecordsComponent;

  public window: any;
  public matchFields: any[] = [{ key: 'description' }, { key: 'name' }];
  public newItem: any = { id: '99', address: 999, name: 'Lime', description: 'Laura eats limes.' };

  public items: Observable<any> = Observable.of([
    { id: '1', address: 101, name: 'Apple', description: 'Anne eats apples' },
    { id: '2', address: 202, name: 'Banana', description: 'Ben eats bananas' },
    { id: '3', address: 303, name: 'Pear', description: 'Patty eats pears' },
    { id: '4', address: 404, name: 'Grape', description: 'George eats grapes' },
    { id: '5', address: 505, name: 'Banana', description: 'Becky eats bananas' },
    { id: '6', address: 606, name: 'Lemon', description: 'Larry eats lemons' },
    { id: '7', address: 707, name: 'Kiwi', description: 'Kim eats kiwis.' },
    { id: '8', address: 808, name: 'Strawberry', description: 'Sally eats strawberries' }
  ]);

  public matches: Observable<SkyLinkRecordsMatchModel[]> = Observable.of([
    new SkyLinkRecordsMatchModel({
      key: '1',
      status: SKY_LINK_RECORDS_STATUSES.Edit,
      item: { id: '11', address: 111, name: 'Big Apple', description: 'George and his apples' }
    }),
    new SkyLinkRecordsMatchModel({
      key: '2',
      status: undefined,
      item: undefined
    }),
    new SkyLinkRecordsMatchModel({
      key: '3',
      status: SKY_LINK_RECORDS_STATUSES.NoMatch,
      item: undefined
    }),
    new SkyLinkRecordsMatchModel({
      key: '5',
      status: SKY_LINK_RECORDS_STATUSES.Suggested,
      item: { id: '55', address: 555, name: 'Huge Banana', description: 'Barry loves bananas.' }
    }),
    new SkyLinkRecordsMatchModel({
      key: '6',
      status: SKY_LINK_RECORDS_STATUSES.Selected,
      item: { id: '66', address: 666, name: 'Lovely Lemons', description: 'Lisa loves lemons.' }
    }),
    new SkyLinkRecordsMatchModel({
      key: '7',
      status: SKY_LINK_RECORDS_STATUSES.Created,
      item: undefined
    }),
    new SkyLinkRecordsMatchModel({
      key: '8',
      status: SKY_LINK_RECORDS_STATUSES.Linked,
      item: {
        id: '88',
        address: 888,
        name: 'Strawberry Shortcake',
        description: 'Steve loves strawberries'
      }
    })
  ]);

  constructor() {
    this.window = getWindow();
  }

  public showResults() {
    this.item.results.take(1).subscribe((r: any) => this.window.alert(JSON.stringify(r)));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-link-records-demo',
  template: `<h3>
  Link records child templates
</h3>

<sky-link-records
  [items]="items"
  [matches]="matches"
  [matchFields]="matchFields"
  [showNewFieldValues]="false">

  <sky-link-records-item-title>
    <ng-template
      let-item="item">
      Applicant
    </ng-template>
  </sky-link-records-item-title>

  <sky-link-records-item-content>
    <ng-template
      let-item="item">
      <div>Original Item</div>
      <div>{{ item?.id }}</div>
      <div>{{ item?.name }}</div>
      <div>{{ item?.description }}</div>
    </ng-template>
  </sky-link-records-item-content>

  <sky-link-records-match-content>
    <ng-template let-match="match">
      <div>Match Item</div>
      <div>{{ match?.item?.id }}</div>
      <div>{{ match?.item?.name }}</div>
      <div>{{ match?.item?.description }}</div>
    </ng-template>
  </sky-link-records-match-content>

  <sky-link-records-nomatch-content>
    <ng-template
      let-item="item"
      let-match="match"
      let-api="api">
      <div *ngIf="match?.item">
        <div>Match Item</div>
        <div>{{ match?.item?.id }}</div>
        <div>{{ match?.item?.name }}</div>
        <div>{{ match?.item?.description }}</div>
      </div>
      <div *ngIf="!match?.item">
        <div>Match Search</div>
        <button
          class="sky-btn sky-btn-default"
          (click)="api.addSelectedItem(item?.id, newItem)">
          Test Select
        </button>
      </div>
    </ng-template>
  </sky-link-records-nomatch-content>
</sky-link-records>

<button
  class="sky-btn sky-btn-default"
  (click)="showResults()">
  Show Results
</button>

<h3>
  Default link with templates
</h3>

<sky-link-records
  [items]="items"
  [matches]="matches"
  [itemTemplate]="item"
  [matchTemplate]="match"
  [matchFields]="matchFields">
</sky-link-records>

<ng-template #itemTitle let-item="item">Custom Title</ng-template>

<ng-template #item let-item="item">
  <div>{{ item?.name }}</div>
  <div>{{ item?.description }}</div>
</ng-template>

<ng-template #match let-match="match">
  <div>Custom Label:</div>
  <div>{{ match?.item?.name }}</div>
  <div>{{ match?.item?.description }}</div>
</ng-template>

<button
  class="sky-btn sky-btn-default"
  (click)="showResults()">
  Show Results
</button>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: ViewChild, args: [SkyLinkRecordsComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
